var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ai-greeting-wrapper"
  }, [_vm._m(0), _vm._m(1), _c("div", {
    staticClass: "greeting-text"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon-wrapper"
  }, [_c("img", {
    attrs: {
      src: require("../../../../static/img/greeting.png"),
      height: "182px"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ai-greeting"
  }, [_c("div", [_c("div", {
    staticClass: "hello"
  }, [_vm._v("你好呀！")]), _c("div", {
    staticClass: "hello-2"
  }, [_vm._v("我是您的AI合规秘书")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };